var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.4 202.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m156.64,31.76c0,14.33-11.62,25.95-25.95,25.95s-25.95-11.62-25.95-25.95h-24.05c0,27.61,22.39,50,50,50s50-22.39,50-50h-24.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1f4fd",
    d: "m130.69,120.76c-27.61,0-50,22.39-50,50h24.05c0-14.33,11.62-25.95,25.95-25.95s25.95,11.62,25.95,25.95h24.05c0-27.61-22.39-50-50-50Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy);
export default __webpack_public_path__ + "static/media/why.b62033775c9cb5a386c259603e54d45d.svg";
export { ForwardRef as ReactComponent };